// having this function enables us to add optimistic updates later on
export const dispatchThunk = async <T>(
    fn: Promise<T>,
    fulfilled?: (data: T) => void,
    rejected?: (error: T) => void
) => {
    return fn.then(fulfilled).catch(rejected);
};
